import React from 'react';
import { buildSelectMultipleButtonRenderer } from '@gp/utils/renderers';
import {
  FIELD_COMMON_ERR_MSG,
  STAGE_OPTIONS,
  ALL_PLATFORMS_OPTION,
  PLATFORM_OPTIONS,
  PRIORITY_OPTIONS,
  FORM_GROUPS,
  SUB_FORM_GROUPS,
} from '@gp/constants/const';

import type {
  IDynamicFormField,
  IDynamicFormFieldValidator,
  IDynamicFormFieldValidation,
} from '@gp/components/DynamicForm/types';
import type { IDynamicFormControl } from '@gp/components/DynamicForm/components/FormControl/types';

const CONTROL_STYLE1: React.CSSProperties = {
  width: 384,
  // width: 352,
};

const CONTROL_STYLE180: React.CSSProperties = {
  width: 180,
};

const CONTROL_SELECT_PROPS = {
  style: CONTROL_STYLE1,
  showLabel: false,
  clearable: false,
};
const CONTROL_SELECT_IP_PROPS = {
  style: CONTROL_STYLE1,
  showLabel: false,
  clearable: false,
  isNeedEmptyAll: false,
  showPlaceholder: true,
};
const CONTROL_SELECT_PROPS_STUDIO = {
  style: CONTROL_STYLE180,
  showLabel: false,
  clearable: false,
};

const CONTROL_SELECTMULTIPLE_PROPS = {
  ...CONTROL_SELECT_PROPS,
  boxClassName: 'gp-product-add-or-edit-modal-checkbox',
  showLabel: false,
  required: false,
  clearable: false,
  isNeedEmptyAll: false,
  showPlaceholder: true,
  // allOption: false,
};

// 字段集合
export const FIELDS: IDynamicFormField[] = [
  {
    key: 'project',
    type: 'input',
    required: true,
    label: 'Project Name',
  },
  {
    key: 'stage',
    type: 'customizeTagSelectMultiple',
    required: true,
    label: 'Stage',
    className: 'gp-product-form-item-newAdded-right',
  },
  {
    key: 'platform',
    type: 'selectMultiple',
    required: true,
    label: 'Platform',
  },
  {
    key: 'studio_entity_id',
    type: 'select',
    required: true,
    label: 'Studio',
  },
  {
    key: 'priority',
    type: 'select',
    required: true,
    label: 'Priority',
  },
  {
    key: 'group',
    type: 'composedSelect',
    required: true,
    label: 'Group',
  },
  // {
  //   key: 'form_2',
  //   type: 'input',
  //   required: false,
  //   label: 'Codev Developer',
  // },
  {
    key: 'publisher',
    type: 'input',
    required: true,
    label: 'Publishing Team',
  },
  {
    key: 'business_model',
    type: 'selectMultiple',
    required: true,
    label: 'Business Model',
  },
  {
    key: 'ip',
    type: 'select',
    required: false,
    label: 'IP',
  },
  {
    key: 'genre',
    type: 'selectMultiple',
    required: true,
    label: 'Genre',
  },
  // {
  //   key: 'expanded_genre',
  //   type: 'input',
  //   required: false,
  //   label: 'Expanded Genre',
  // },
  // {
  //   key: 'tag_line',
  //   type: 'textarea',
  //   required: false,
  //   label: 'Tagline',
  // },
  // {
  //   key: 'ambition',
  //   type: 'textarea',
  //   required: false,
  //   label: 'Ambition',
  // },
];
export const FIELDS_BASIC: IDynamicFormField[] = [
  {
    key: 'project',
    type: 'input',
    required: true,
    label: 'Project Name',
  },
  {
    key: 'stage',
    type: 'select',
    required: true,
    label: 'Stage',
    className: 'gp-product-form-item-newAdded-right',
  },
  {
    key: 'pro_coa',
    type: 'input',
    required: true,
    label: 'COA',
  },
  {
    key: 'pro_coa_id',
    type: 'input',
    required: true,
    label: 'COA ID',
  },
];
export const FIELDS_TEAM: IDynamicFormField[] = [
  {
    key: 'studio_entity_id',
    type: 'doubleSelect',
    required: true,
    label: 'Studio',
  },
  {
    key: 'studio_location',
    type: 'input',
    required: true,
    label: 'Studio Location',
  },
  {
    key: 'publisher',
    type: 'input',
    required: true,
    label: 'Publishing Team',
  },
];
export const FIELDS_GAME: IDynamicFormField[] = [
  {
    key: 'ip',
    type: 'selectMultiple',
    required: false,
    label: 'IP',
  },
  {
    key: 'genre',
    type: 'selectMultiple',
    required: true,
    label: 'Genre',
  },
  {
    key: 'platform',
    type: 'selectMultiple',
    required: true,
    label: 'Platform',
  },
  {
    key: 'business_model',
    type: 'selectMultiple',
    required: true,
    label: 'Business Model',
  },
  {
    key: 'engine',
    type: 'customizeTagSelectMultiple',
    required: true,
    label: 'Engine',
  },
];

// 字段控件映射
export const CONTROLS: Record<string, Partial<IDynamicFormControl>> = {
  project: {
    style: CONTROL_STYLE1,
  },
  pro_coa: {
    style: CONTROL_STYLE1,
  },
  pro_coa_id: {
    style: CONTROL_STYLE1,
    isOnlyNum: true,
  },
  studio_location: {
    style: CONTROL_STYLE1,
    // disabled: true,
  },
  stage: {
    ...CONTROL_SELECT_PROPS,
    options: STAGE_OPTIONS,
  },
  engine: {
    ...CONTROL_SELECT_PROPS,
    options: STAGE_OPTIONS,
  },
  platform: {
    ...CONTROL_SELECTMULTIPLE_PROPS,
    options: PLATFORM_OPTIONS,
    // allOption: ALL_PLATFORMS_OPTION,
    // button: buildSelectMultipleButtonRenderer({
    //   placeholder: 'Please select Platform',
    //   allOption: ALL_PLATFORMS_OPTION,
    //   options: PLATFORM_OPTIONS,
    // }),
  },
  studio_entity_id: {
    ...CONTROL_SELECT_PROPS_STUDIO,
    searchable: true,
    options: [],
  },
  priority: {
    ...CONTROL_SELECT_PROPS,
    options: PRIORITY_OPTIONS,
  },
  group: {
    style: { ...CONTROL_STYLE1, width: '100%' },
    leftLabel: 'Group',
    leftPlaceholder: 'Select Group',
    leftProps: {
      clearable: false,
    },
    rightLabel: 'Sub Form',
    rightPlaceholder: 'Select Sub Form',
    rightProps: {
      clearable: false,
    },
    parentOptions: FORM_GROUPS,
    childOptionsMap: SUB_FORM_GROUPS,
  },
  // form_2: {
  //   style: CONTROL_STYLE1,
  // },
  publisher: {
    style: CONTROL_STYLE1,
  },
  business_model: {
    ...CONTROL_SELECTMULTIPLE_PROPS,
    options: [
      { value: 'F2P', text: 'F2P' },
      { value: 'Premium', text: 'Premium' },
      { value: 'Downloadable Content', text: 'Downloadable Content' },
      { value: 'Microtransaction', text: 'Microtransaction' },
      { value: 'Subscription', text: 'Subscription' },
    ],
    placeholder: 'Please select Business Model',
    // button: buildSelectMultipleButtonRenderer({
    //   placeholder: 'Please select Business Model (Multiple Selection)',
    // }),
  },
  ip: {
    ...CONTROL_SELECT_IP_PROPS,
    options: [
      { value: 'Existing', text: 'Existing' },
      { value: 'New', text: 'New' },
      { value: 'Licensed', text: 'Licensed' },
    ],
  },
  genre: {
    ...CONTROL_SELECTMULTIPLE_PROPS,
    options: [
      { value: 'Shooter', text: 'Shooter' },
      { value: 'RPG', text: 'RPG' },
      { value: 'Action', text: 'Action' },
      { value: 'SOC', text: 'SOC' },
      { value: 'MMO', text: 'MMO' },
      { value: 'MOBA', text: 'MOBA' },
      { value: 'Card', text: 'Card' },
      { value: 'Casual', text: 'Casual' },
      { value: 'Racing', text: 'Racing' },
    ],
    placeholder: 'Please select Genre',
    // button: buildSelectMultipleButtonRenderer({
    //   placeholder: 'Please select Genre (Multiple Selection)',
    // }),
  },
  // expanded_genre: {
  //   style: CONTROL_STYLE1,
  // },
  // tag_line: {
  //   size: 'full',
  // },
  // ambition: {
  //   size: 'full',
  // },
};

// 字段检验器配置
export const VALIDATORS: Record<string, IDynamicFormFieldValidator> = {
  project: {
    required: true,
  },
  stage: {
    required: true,
  },
  pro_coa: {
    required: true,
  },
  pro_coa_id: {
    required: true,
  },
  studio_entity_id: {
    required: true,
  },
  studio_location: {
    required: true,
  },
  publisher: {
    required: true,
  },
  ip: {
    required: false,
  },
  genre: {
    required: true,
  },
  platform: {
    required: true,
  },
  business_model: {
    required: true,
  },
  engine: {
    required: true,
  },
};

// 字段校验结果信息映射
export const VALIDATIONS: Record<string, IDynamicFormFieldValidation> = {
  project: {
    status: 'success',
    message: '',
  },
  stage: {
    status: 'success',
    message: '',
  },
  pro_coa: {
    status: 'success',
    message: '',
  },
  pro_coa_id: {
    status: 'success',
    message: '',
  },
  studio_entity_id: {
    status: 'success',
    message: '',
  },
  studio_location: {
    status: 'success',
    message: '',
  },
  publisher: {
    status: 'success',
    message: '',
  },
  // ip: {
  //   status: 'success',
  //   message: '',
  // },
  genre: {
    status: 'success',
    message: '',
  },
  platform: {
    status: 'success',
    message: '',
  },
  business_model: {
    status: 'success',
    message: '',
  },
  engine: {
    status: 'success',
    message: '',
  },

  // priority: {
  //   status: 'success',
  //   message: '',
  // },
  // group: {
  //   status: 'success',
  //   message: '',
  // },
  // form_2: {
  //   status: 'success',
  //   message: '',
  // },

  // expanded_genre: {
  //   status: 'success',
  //   message: '',
  // },
  // tag_line: {
  //   status: 'success',
  //   message: '',
  // },
  // ambition: {
  //   status: 'success',
  //   message: '',
  // },
};
